import { createSelector } from "reselect";

import { Room, AppState } from "./model";

export const routeIdSelector = (state: AppState) => state.router.params!.roomId!; // eslint-disable-line @typescript-eslint/no-non-null-assertion

export type SelectorState = AppState;

export const roomsSelector = (state: AppState) => state.rooms;

export const roomSelector = createSelector(
    roomsSelector,
    routeIdSelector,
    (rooms: Room[], id: string): Room | undefined => {
        return rooms.find(c => c.id === id);
    }
);

export const basePathSelector = (state: AppState) =>
    state.router.pathname!.substring(0, state.router.pathname!.indexOf("rooms") + "rooms".length); // eslint-disable-line @typescript-eslint/no-non-null-assertion, max-len
